import script from "./forcastchart.vue?vue&type=script&lang=js"
export * from "./forcastchart.vue?vue&type=script&lang=js"

import "./forcastchart.vue?vue&type=style&index=0&id=404a93fe&lang=scss"

const __exports__ = script;

export default __exports__